/**
 * Pure email-format validation used by the email-edit screen and its tests.
 * Kept in lib/ so it can be imported in the Node/vitest environment without
 * pulling in React Native modules.
 */

// Simple RFC 5322-ish email regex — sufficient for client-side gate.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** Validate an email string and return an error string, or '' if valid. */
export function validateEmail(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return 'Email is required'
  if (!EMAIL_RE.test(trimmed)) return 'Enter a valid email address'
  return ''
}
